function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-sh-viz-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const isPositive = $helpers.isPositive();
        const viewValues = $helpers.getValues();
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Details");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-formatted-message", {
            "attrs": {
              parts: JSON.stringify($helpers.getMessage())
            },
            "class": {
              'mp-sh-viz-message': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-viz-bar-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                width: `${viewValues.minPercentage}%`
              },
              "class": Object.assign({}, {
                'mp-sh-viz-bar-left': true
              }, {
                'mp-sh-viz-bar-inner': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'mp-sh-viz-expected-color': isPositive,
                  'mp-sh-viz-actual-color': !isPositive,
                }, {
                  'mp-sh-viz-bar-color': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-sh-viz-number': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("" + (viewValues.formattedMin) + "");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                width: `${viewValues.maxPercentage}%`
              },
              "class": Object.assign({}, {
                'mp-sh-viz-bar-right': true
              }, {
                'mp-sh-viz-bar-inner': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'mp-sh-viz-expected-color': !isPositive,
                  'mp-sh-viz-actual-color': isPositive,
                }, {
                  'mp-sh-viz-bar-color': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-sh-viz-number': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("" + (viewValues.formattedMax) + "");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-viz-key': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-sh-viz-color-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-sh-viz-actual-color': true,
                  'mp-sh-viz-color-sample': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-sh-viz-color-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Actual");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-sh-viz-color-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-sh-viz-expected-color': true,
                  'mp-sh-viz-color-sample': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-sh-viz-color-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Expected");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;